<template>
    <div class="not-my-car__container container">
        <div class="not-my-car__alert-container">
            <VehicleNotFoundModal v-if="!otherSelected"> </VehicleNotFoundModal>
        </div>
        <h2 class="valuation__title">Please fill in your vehicle details below...</h2>
        <div class="rd-card rd-card--border-top not-my-car__card">
            <form @submit.prevent="submit" id="manual-form" ref="manual-form" name="manual-form" method="post" class="material-form details-form summary__form" style="position: relative;">
                <h3 class="card__heading">Your vehicle details:</h3>
                <div class="not-my-car__form">
                    <div v-if="otherSelected" class="form-element__container">
                        <input v-model="details.reg_no" name="reg_no" class="form-element__input form-control form-control--text" type="text" placeholder="Registration*" data-validate="input" data-validate-message="Please enter your vehicles registration" data-error-target="manual-form-container" />
                    </div>
                    <div v-if="otherSelected" class="form-element__container">
                        <input v-model="details.mileage" name="mileage" class="form-element__input form-control form-control--text" type="text" placeholder="Mileage*" data-validate="input" data-validate-message="Please enter your vehicles mileage" data-error-target="manual-form-container" />
                    </div>
                    <div class="form-element__container">
                        <input v-model="details.make" name="make" class="form-element__input form-control form-control--text" type="text" placeholder="Make*" data-validate="input" data-validate-message="Please enter your vehicles make" data-error-target="manual-form-container" />
                    </div>
                    <div class="form-element__container">
                        <input v-model="details.variant" name="variant" class="form-element__input form-control form-control--text" type="text" placeholder="Derivative/ description*" data-validate="input" data-validate-message="Please enter your vehicles description" data-error-target="manual-form-container" />
                    </div>
                    <div class="form-element__container not-my-car__model ">
                        <input v-model="details.model" name="model" class="form-element__input form-control form-control--text" type="text" placeholder="Model*" data-validate="input" data-validate-message="Please enter your vehicles model" data-error-target="manual-form-container" />
                    </div>
                    <div class="form-element__container">
                        <input v-model="details.extraInfo" name="extraInfo" class="form-element__input form-control form-control--text" type="text" placeholder="Anything else?" />
                    </div>
                </div>
                <button type="submit" class="btn btn--primary card__button not-my-car__button">Continue</button>
            </form>
        </div>
    </div>
</template>

<script>
import VehicleNotFoundModal from "./VehicleNotFoundModal.vue"
import { mapActions, mapState } from "vuex/dist/vuex.esm.browser";

export default {
    components: {
        VehicleNotFoundModal,
    },
    data() {
        return {
            validator: false,
            details: {}
        }
    },

    mounted() {
        this.$nextTick(() => {
            const form = this.$refs['manual-form'];
            this.validator = new ContactFormValidator({
                element: form,
                vueForm: true,
                redesign: true
            });
        });
    },

    computed: {
        ...mapState("ValuationTool", ["registration", "otherSelected"]),
    },

    methods: {
        ...mapActions('ValuationTool', ['updateNonFranchiseVehicleDetails']),
        async submit() {
            this.validator.errorResponse();
            if (!await this.validator.isValid()) {
                this.validator.scrollToFirstError();
                return;
            }
            this.updateNonFranchiseVehicleDetails(this.details);
        },
    },
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/valuation-tool/components/Sections/ManualValuationForm.vue